import React from 'react'
import { Tooltip } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

export default function DetalleEnHistograma (props) {
  const { tooltipText, value } = props
  return (
    <Tooltip title={tooltipText}>
      <span
        style={{
          color: tooltipText ? '#ff722a' : COLORES.grey.dark,
          fontWeight: (tooltipText ? 'bold' : 'inherit')
        }}
      >
        {value}
      </span>
    </Tooltip>

  )
}
